import { createSaga } from './saga-helpers';

import * as Api from '../api/teams-api';

const watchGetTeams = createSaga({
    type: 'TEAMS_FETCH',
    fn: Api.fetchTeams,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchGetLinkedTeams = createSaga({
    type: 'LINKED_TEAMS_FETCH',
    fn: Api.fetchLinkedTeams,
    args: action => [action.payload],
    successPayload: (items, action) => ({
        items
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateTeam = createSaga({
    type: 'TEAM_CREATE',
    fn: Api.createTeam,
    args: action => [action.payload.team],
    successPayload: (team, action) => ({
        teamUrl: team.url,
        fragment: action.payload.team,
        team
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.team
    })
});

const watchGetTeam = createSaga({
    type: 'TEAM_FETCH',
    fn: Api.fetchTeam,
    args: action => [],
    successPayload: team => ({ team })
});

const watchGetTeamDetails = createSaga({
    type: 'TEAM_DETAILS_FETCH',
    fn: Api.fetchTeamDetails,
    args: action => [],
    successPayload: teamDetails => ({ teamDetails })
});

const watchUpdateTeam = createSaga({
    type: 'TEAM_UPDATE',
    fn: Api.updateTeam,
    args: action => [action.payload.teamProps],
    successPayload: team => ({ team })
});

const watchRemoveTeam = createSaga({
    type: 'TEAM_REMOVE',
    fn: Api.removeTeam,
    args: action => [action.payload.withUser]
});

const watchInviteTeamUsers = createSaga({
    type: 'TEAM_INVITE_USERS',
    fn: Api.inviteTeamUsers,
    args: action => [action.payload.users],
    successPayload: (response, action) => ({
        users: response.invited
    })
});

const watchTransferTeam = createSaga({
    type: 'TEAM_TRANSFER',
    fn: Api.transferTeam,
    args: action => [action.payload.teamUrl, action.payload.userId, action.payload.role],
    successPayload: team => ({ team })
})

const sagas = [watchGetTeams, watchGetLinkedTeams, watchCreateTeam, watchGetTeam, watchGetTeamDetails, watchUpdateTeam, watchRemoveTeam, watchInviteTeamUsers, watchTransferTeam];

export default sagas;
